import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

// Re-authored from ../design-system/components/feedback/Skeleton.jsx. Shimmer
// keyframe lives in index.css (.ollio-skel) — a moving ::after gradient can't be
// expressed as Tailwind utilities.
export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  shape?: 'text' | 'rect' | 'circle';
  width?: number | string;
  height?: number | string;
  radius?: number | string;
}

const shapeClass = {
  text: 'h-[0.8em] rounded-full',
  rect: 'rounded-[var(--radius-card)]',
  circle: 'rounded-full',
} as const;

export function Skeleton({ shape = 'text', width, height, radius, className, style, ...rest }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('ollio-skel block bg-[var(--ollio-cream-200)]', shapeClass[shape], className)}
      style={{ width, height, borderRadius: radius, ...style }}
      {...rest}
    />
  );
}
